import { getRuLocatedDateWithMonth } from 'utils/dates';
const ZERO_STRING = '0';

export const getPrice = (cost, text, preText, textFree) => {
  if (cost !== ZERO_STRING && cost) {
    return `${preText} ${cost} ${text}`;
  }
  return textFree;
};

export const priceWithDiscount = (discount, unit) => {
  if (discount?.priceWithoutDiscount) {
    const { percent, priceWithoutDiscount } = discount;
    if (percent !== 100 && priceWithoutDiscount) {
      const fixedPrice = percent / 100 * priceWithoutDiscount;
      const truncPrice = Math.trunc(fixedPrice * 100) / 100;

      return `${truncPrice} ${unit}`;
    }
    return 'Бесплатно';
  }
  return null;
};

export const priceWithDate = (discount, discountPrice) => {
  if (discountPrice && typeof discount?.expirationDate === 'string') {
    const { expirationDate } = discount;
    return `${discountPrice} до ${getRuLocatedDateWithMonth(expirationDate)}`;
  }
  return discountPrice;
};

export const displayedPriceText = (discount, price, unit) => {
  if (discount) {
    return discount.toLowerCase().startsWith('бесплатно') ? 'Бесплатно' : `Стоимость услуги ${discount}`;
  }
  return getPrice(price, unit, 'Стоимость услуги', 'Бесплатно');
};
